import React from "react";
import { MapPin, Tag, Download, Mail, Sparkles, Share2, Loader2 } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";

/**
 * Topp-sektion av ärendevyn: ref, titel, adress, typ, status & knappar.
 */
export default function CaseHeader({
  c, user, onExportPdf, onForward, onAiReview, onShare, aiLoading,
}) {
  const isAdmin = user?.role === "admin";

  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
      <div className="min-w-0">
        <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold">{c.ref}</div>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight text-zinc-900" style={{ fontFamily: "Outfit" }}>
          {c.title}
        </h1>
        <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-1 text-sm text-zinc-600">
          {c.address && <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {c.address}</span>}
          <span className="flex items-center gap-1.5"><Tag className="w-3.5 h-3.5" /> {c.case_type}</span>
        </div>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <StatusBadge status={c.status} />
        <button data-testid="export-pdf" onClick={onExportPdf}
          className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 border border-zinc-300 rounded-sm hover:bg-zinc-100"
          title="Ladda ner en färdig ansökan-PDF att bifoga i mail till kommunen">
          <Download className="w-3.5 h-3.5" /> Ladda ner ansökan
        </button>
        {isAdmin && (
          <button data-testid="forward-municipality-btn" onClick={onForward}
            className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 bg-blue-700 hover:bg-blue-800 text-white rounded-sm">
            <Mail className="w-3.5 h-3.5" /> Vidarebefordra till kommun
          </button>
        )}
        {!isAdmin && (
          <>
            <button data-testid="ai-review-btn" onClick={onAiReview} disabled={aiLoading}
              className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 bg-blue-700 hover:bg-blue-800 disabled:opacity-60 text-white rounded-sm">
              {aiLoading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />} AI-granska
            </button>
            <button data-testid="share-btn" onClick={onShare}
              className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 border border-zinc-300 rounded-sm hover:bg-zinc-100">
              <Share2 className="w-3.5 h-3.5" /> Dela
            </button>
          </>
        )}
      </div>
    </div>
  );
}
